const stringP = `['"].*['"]`;
const variableP = "[A-Za-z0-9_]+";
const operationP = `\\s*(${stringP}|${variableP})\\s*[+]\\s*(${stringP}|${variableP})\\s*`;
const statementP = `${variableP}|${stringP}|${operationP}`;
const conditionalP = `\\s*(${variableP})\\s*\\?\\s*(${statementP})\\s*:\\s*(${statementP})+\\s*`;
const outsideQuotesLookahead = "(?=(([^']*'[^']*')*[^']*)$)";

const conditionalRe = new RegExp(conditionalP);
const operationRe = new RegExp(operationP);
const splitConditionalRe = new RegExp(`\\?${outsideQuotesLookahead}`);
const splitOperationRe = new RegExp(`\\+${outsideQuotesLookahead}`);
const splitStatementsRe = new RegExp(`:${outsideQuotesLookahead}`);
const stringRe = new RegExp(stringP);

const outerWhiteSpaceRE = /^(\s+)|(\s+)$/g;
const stripOuterWhitespace = (token) => token.replace(outerWhiteSpaceRE, "");

const tokenDelimiterRE = /^(\$\{)|(\})$/g;
const stripTokenDelimiter = (token) => token.replace(tokenDelimiterRE, "");

const whiteSpaceRE = /\s+/g;
const stripWhitespace = (token) => token.replace(whiteSpaceRE, "");

const quotationRE = /["']/g;
const resolveToken = (token, data) => {
  const stringToken = stringRe.test(token);

  return stringToken
    ? stripOuterWhitespace(token).replace(quotationRE, "")
    : data[stripWhitespace(token)];
};

const resolveOperation = (token, data) => {
  const [a, b] = token.split(splitOperationRe);

  return resolveToken(a, data) + resolveToken(b, data);
};

const resolveData = (token, data = {}) => {
  const tokenIsOperation = operationRe.test(token);

  return tokenIsOperation ? resolveOperation(token, data) : resolveToken(token, data);
};

const evaluateConditional = (token, data) => {
  const [expression, statements] = token.split(splitConditionalRe);
  const [statement1, statement2] = statements.split(splitStatementsRe);
  const statement = data[stripWhitespace(expression)]
    ? stripOuterWhitespace(statement1)
    : stripOuterWhitespace(statement2);

  return resolveData(statement, data);
};

const interpolateToken = (token, data) => {
  const strippedToken = stripTokenDelimiter(token);
  const tokenIsConditional = conditionalRe.test(strippedToken);

  return tokenIsConditional
    ? evaluateConditional(strippedToken, data)
    : resolveData(strippedToken, data);
};

const actionTokenDelimiter = "${@";
const tokenDelimiter = "${";
const tokenRE = /(\$\{.*?\})/;
const interpolate = (template, data) => {
  const interpolatable =
    template?.includes?.(tokenDelimiter) && !template?.includes?.(actionTokenDelimiter);
  let result = template;

  if (interpolatable) {
    const tokens = template.split(tokenRE).filter((token) => !!token);

    result = tokens
      .map((token) => (token.includes(tokenDelimiter) ? interpolateToken(token, data) : token))
      .join("");
  }

  return result;
};

export default interpolate;
